import SocketBroker from '@Services/SocketBroker';

export default class SocketBrokerObservableWrapper {
  _unsubscribe;

  observe(channel, callback) {
    this._unsubscribe = SocketBroker.observe(channel, callback);
  }

  // This method is important! It is part of Unsubscribable rxjs interface
  unsubscribe() {
    if (this._unsubscribe) {
      this._unsubscribe();
    }
  }
}
